import { createContext, ReactNode, useContext } from "react";

import { useFilterInvoice } from "./filter-invoice.hook";

const FilterInvoiceContext = createContext(
  {} as ReturnType<typeof useFilterInvoice>
);
export function useFilterInvoiceContext() {
  return useContext(FilterInvoiceContext);
}

interface FilterInvoiceProviderProps {
  children: ReactNode;
}
export function FilterInvoiceProvider({
  children,
}: FilterInvoiceProviderProps) {
  return (
    <FilterInvoiceContext.Provider value={useFilterInvoice()}>
      {children}
    </FilterInvoiceContext.Provider>
  );
}